import isPropValid from "@emotion/is-prop-valid";
import { Runtime, StyledTarget } from "styled-components/dist/types";

// This implements the default behavior from styled-components v5
// FIXME: Remove if code is refactored to v6 style
// https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
export const shouldForwardProp = (
  propName: string,
  target: StyledTarget<Runtime>
): boolean => {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};
